import React, { Component } from "react";
import { connect } from "react-redux";
import { getAllUsers } from "redux/actions/InboxActions";
import { CircularProgress } from "@material-ui/core";
import { getUserDisplay, getUserNameWithDetails } from "./CommonFunc";

class UserDisplay extends Component {
  render() {
    const { userId, users, loadingUsers, showUserIdIfNot } = this.props;
    if (loadingUsers) return <CircularProgress className={"userLoading"} />;
    let fomattedName = "";
    if(userId && showUserIdIfNot){
      return getUserDisplay(userId);
    }
    else if(userId){
      let user = users.find((v) => {
        if(v.externalRefId && typeof v.externalRefId == "string" && typeof userId == "string"){
          return v.externalRefId.toLowerCase() == userId.toLowerCase();
        }
      })
      if(user){
        fomattedName = getUserNameWithDetails(user);
      }
    }
    return(
      // <span title={(users.find((v) => +v.userId === +userId) || { name: "" }).name + " " + (users.find((v) => +v.userId === +userId) || { email: "" }).email}>{(users.find((v) => +v.userId === +userId) || { name: "" }).name + " " + (users.find((v) => +v.userId === +userId) || { email: "" }).email} </span>
      // <span title={getUserNameWithDetails(users.find((v) => +v.userId === +userId) || { name: " " })}>{getUserNameWithDetails(users.find((v) => +v.userId === +userId) || { name: " " })} </span>
      <span title={fomattedName}>{fomattedName} </span>
    ) ;
  }

  componentDidMount() {
    // const { users, loadingUsers, getAllUsers } = this.props;
    // if (!loadingUsers && !users?.length) {
    //   getAllUsers();
    // }
  }
}

const mapStateToProps = (state) => ({
  users: state.inbox.allUsers,
  loadingUsers: state.inbox.loading,
});

export default connect(mapStateToProps, { getAllUsers })(UserDisplay);
